import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EditorJS from '@editorjs/editorjs';

import DocumentInstructionModal from './DocumentInstructionModal';
import { addInstructionEventByEditor } from '../utils';
import { InstructionEvent } from '../types';
import {
  setDocumentPageInstructionId,
  setOpenDocumentPageInstructionModal,
  setInlineDocumentPageInstruction,
} from '../../../../store/modules/script-editor/actions';
import { selectDocumentPageInstruction } from '../../../../store/modules/script-editor/selectors';
import { addEventListenerToDocumentActions } from './utils';
import {Formik} from "formik";

type Props = {
  instanceEditor: EditorJS | undefined;
  refEditor: HTMLDivElement | null;
};

const DocumentInstructionComponent = ({ instanceEditor, refEditor }: Props) => {
  const dispatch = useDispatch();
  const { isOpenModal } = useSelector(selectDocumentPageInstruction);

  useEffect(() => {
    if (instanceEditor) {
      addInstructionEventByEditor(
        instanceEditor,
        InstructionEvent.OPEN_DOCUMENT_PAGE_INSTRUCTION_MODAL,
        (data) => {
          dispatch(setOpenDocumentPageInstructionModal(true));
          dispatch(setDocumentPageInstructionId(data.instructionId));
          dispatch(setInlineDocumentPageInstruction(data.isInline));
        },
      );
      addInstructionEventByEditor(
        instanceEditor,
        InstructionEvent.UPDATE_DOCUMENT_PAGE_ACTION_EVENT_LISTENERS,
        // eslint-disable-next-line
        ({ refEditor, instanceEditor }) => {
          addEventListenerToDocumentActions({ instanceEditor, refEditor });
        },
      );
    }
  }, [dispatch, instanceEditor]);

  useEffect(() => {
    if (instanceEditor && refEditor) {
      addEventListenerToDocumentActions({ instanceEditor, refEditor });
    }
  }, [instanceEditor, refEditor]);

  if (!isOpenModal) {
    return null;
  }

  return (
    <Formik initialValues={{document: '', page: ''}} onSubmit={()=>{}}>
      <DocumentInstructionModal instanceEditor={instanceEditor} />
    </Formik>
  );
};

export default DocumentInstructionComponent;
